document.addEventListener('DOMContentLoaded', function() {
  const mediaQuery = window.matchMedia('(min-width: 990px)');
  
  function applyDetailsBehavior() {
      if (mediaQuery.matches) {
          document.querySelectorAll('.header__inline-menu details').forEach(details => {
              const openDetails = () => details.setAttribute('open', '');
              const closeDetails = () => details.removeAttribute('open');
  
              // Add event listeners
              details.addEventListener('mouseenter', openDetails);
              details.addEventListener('mouseleave', closeDetails);
              details.addEventListener('focusin', openDetails);
              details.addEventListener('focusout', closeDetails);
  
              // Cleanup to prevent duplicate listeners
              details.cleanup = () => {
                  details.removeEventListener('mouseenter', openDetails);
                  details.removeEventListener('mouseleave', closeDetails);
                  details.removeEventListener('focusin', openDetails);
                  details.removeEventListener('focusout', closeDetails);
              };
          });
      } else {
          // Cleanup listeners if the behavior is disabled
          document.querySelectorAll('ul.list-menu > details').forEach(details => {
              if (details.cleanup) details.cleanup();
          });
      }
  }
  
  // Add listener for screen size changes
  mediaQuery.addEventListener('change', applyDetailsBehavior);
  
  // Initial application
  applyDetailsBehavior();

})
